export const roundValue = (value = 0, count = 2) => {
  return Math.round(value * Math.pow(10, count)) / Math.pow(10, count)
}